import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { emitirPDFs, emitirPDFTerceros, verificarAptos } from "../../../actions/basesCertActions";
import useSelectProyecto from "../../../hooks/useSelectProyectos";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { avisoError } from "../../components/AvisosMensajes/MensajesSwalf";

const FormularioEmision = () => {
	const dispatch = useDispatch();
	const [proyecto, SelectProyecto] = useSelectProyecto(null);
	const [emitirConNota, setEmitirConNota] = useState(true);
	const { aptos, loading } = useSelector((state) => state.bases);
	const { usuario } = useSelector((state) => state.usuario);
	const traerDatos = () => {
		if (proyecto) {
			const datosFiltro = {
				proyecto: proyecto ? proyecto.id_proyecto : null,
			};

			console.log(datosFiltro)
			dispatch(verificarAptos(datosFiltro));
		} else {
			avisoError("Debe seleccionar un producto...");
		}
	};

	const emitirDocumentos = () => {
		if (aptos.length) {
			dispatch(emitirPDFs(aptos, usuario, emitirConNota));
		}
	};
	
	const emitirDocumentosTerceros = () => {
		if (aptos.length) {
			dispatch(emitirPDFTerceros(aptos, usuario, emitirConNota));
		}
	}
	return (
		<div className="box">
			<div className="box-header with-border">
				<h5 style={{ color: "#434343" }}>
					<FontAwesomeIcon icon={faSearch} /> Acciones de emisión:
				</h5>
			</div>
			<div className="row p-2">
				<div className="col-9 mb-2">
					<label htmlFor="">Producto:</label>
					<SelectProyecto />
				</div>
				<div className="col-12 pt-4">
					{aptos.length && proyecto ? (
					<div
						className="d-flex align-items-center justify-content-between flex-wrap mb-3 px-3 py-2"
						style={{
							background: "linear-gradient(90deg, #f4f7ff 0%, #eef8ff 100%)",
							border: "1px solid #d8e4ff",
							borderRadius: "10px",
						}}
					>
						<div className="mr-3">
							<span className="d-block" style={{ fontWeight: 600, color: "#2f4a7d" }}>
								Formato del diploma
							</span>
							<small style={{ color: "#5f6f8f" }}>
								Seleccione si la emisión incluirá nota final.
							</small>
						</div>

						<div className="d-flex align-items-center">
							<span
								className="badge mr-3"
								style={{
									backgroundColor: emitirConNota ? "#4169e1" : "#6c757d",
									color: "#fff",
									fontSize: "12px",
									padding: "7px 10px",
								}}
							>
								{emitirConNota ? "Con nota" : "Sin nota"}
							</span>
							<div className="custom-control custom-switch">
								<input
									type="checkbox"
									className="custom-control-input"
									id="switch-nota-diploma"
									checked={emitirConNota}
									onChange={() => setEmitirConNota(!emitirConNota)}
								/>
								<label className="custom-control-label" htmlFor="switch-nota-diploma">
									{emitirConNota ? "Incluir nota final" : "Ocultar nota final"}
								</label>
							</div>
						</div>
					</div>) : null}

					<button className="btn btn-primary" onClick={traerDatos}>
						Consultar
					</button>
					{aptos.length && proyecto ? (
						<>
							{" "}
							<button
								className="btn btn-primary"
								onClick={emitirDocumentos}
							>
								Emitir
							</button>{" "}
							{/* <button
								className="btn btn-primary"
								onClick={emitirDocumentosTerceros}
							>
								Emitir a terceros
							</button> */}
							<a
								className="btn btn-primary"
								href={`https://apisistema.gestoraperu.pe/admin/excel/reporte/aptos/${proyecto.id_proyecto}`}
							>
								Descargar Nómina
							</a>{" "}
						</>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default FormularioEmision;
